import React from 'react';
import './sns.scss';
import Icon from '../../ui-elements/icon/icon';

var SNS = function SNS(_ref) {
  var width = _ref.width,
      height = _ref.height,
      place = _ref.place;
  var iconColor = 'rgb(245, 245, 245)';
  return /*#__PURE__*/React.createElement("ul", {
    className: "sns sns--" + place
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/kentotakeuchi?tab=repositories",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-github",
    color: iconColor
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/in/takeuchi-kento-101b3549/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-linkedin",
    color: iconColor
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/mikiotanaka/?hl=en",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-instagram",
    color: iconColor
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/mikio.tanaka.001",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-facebook",
    color: iconColor
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/KentoTakeuchi",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: width,
    height: height,
    id: "icon-twitter",
    color: iconColor
  }))));
};

export default SNS;